import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7471186c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { ref, onMounted, inject } from "vue";
import { get, set } from "@vueuse/core";
import ImageSpinner from "../spinner.vue";
import Dialog from "primevue/dialog";
import { DirectMessageServices } from "@/clinic/services";
import { IDirectMessage } from "@/clinic/typings";
import { MessageSenderEnum } from "@/clinic/typings/enums/direct-message";

type IImageDialog = {
  id: number;
  content?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'image',
  props: {
    id: null,
    content: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  id: number;
  content?: string;
};

const visible = ref(false);

const closable = ref(true);

const image = ref("");

const boxImageSpinner = ref<HTMLElement>();

const show = () => set(visible, true);

const hide = () => set(visible, false);



const clinicId = inject<number>("clinicId");

const onShow = async () => {
  show();
  get(boxImageSpinner)?.show();
  const { data } = await DirectMessageServices.getMessage(
    { id: props.id, clinic_id: get(clinicId) as number },
    () => {
      get(boxImageSpinner)?.hide();
      set(closable, true);
    },
    () => undefined
  );
  const { content, sender_type } = get(data) as unknown as IDirectMessage;
  set(image, `${sender_type == MessageSenderEnum.customer ? "data:image/png;base64," : ""}${content}`);
};

onMounted(() => get(boxImageSpinner)?.hide());

// eslint-disable-next-line no-undef
expose({
  onShow,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: visible.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    modal: "",
    draggable: false,
    class: "w-full h-full max-h-full image-dialog border-noround",
    onHide: hide,
    closable: closable.value
  }, {
    default: _withCtx(() => [
      _createVNode(ImageSpinner, {
        ref_key: "boxImageSpinner",
        ref: boxImageSpinner,
        hasFull: false,
        loadMore: true,
        className: "top-0 image-spinner"
      }, null, 512),
      (!_unref(get)(boxImageSpinner.value)?.getVisible() && image.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            role: "presentation",
            alt: "image",
            src: image.value
          }, null, 8, _hoisted_1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "closable"]))
}
}

})